"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getPodFetchersById = exports.getPodFetchersByAddressOrEns = void 0;
var ethers_1 = require("ethers");
var contracts_1 = require("@orcaprotocol/contracts");
var ens_1 = __importDefault(require("./lib/services/ens"));
var config_1 = require("./config");
var utils_1 = require("./lib/utils");
/**
 * Returns Controller, ENS Name and pod ID for a given pod address.
 * @param address Pod address
 */
function getPodFetchersByAddressOrEns(identifier) {
    return __awaiter(this, void 0, void 0, function () {
        var network, multicall, address, Name, ens, name_1, err_1, podId, memberTokenDeployment, MemberToken, controllerAddress, controllerDeployment, Controller, Safe;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    network = config_1.config.network, multicall = config_1.config.multicall;
                    ens = (0, ens_1["default"])();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    // Handle addresses
                    address = ethers_1.ethers.utils.getAddress(identifier);
                    return [4 /*yield*/, ens.getName(address)];
                case 2:
                    name_1 = (_a.sent()).name;
                    if (!name_1)
                        throw new Error('Address did not have an ENS name');
                    Name = ens.name(name_1);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    // Might be ENS name instead of address
                    // If so, resolve it. The getText below will throw if it's not a valid pod.
                    Name = ens.name(identifier);
                    return [4 /*yield*/, multicall.resolveName(Name.name)];
                case 4:
                    address = _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, Name.getText('podId')];
                case 6:
                    podId = _a.sent();
                    if (!podId)
                        throw new Error('No podId on ENS found');
                    memberTokenDeployment = (0, contracts_1.getDeployment)('MemberToken', network);
                    MemberToken = new ethers_1.ethers.Contract(memberTokenDeployment.address, memberTokenDeployment.abi, multicall);
                    return [4 /*yield*/, MemberToken.memberController(podId)];
                case 7:
                    controllerAddress = _a.sent();
                    controllerDeployment = (0, contracts_1.getControllerByAddress)(controllerAddress, network);
                    Controller = new ethers_1.ethers.Contract(controllerDeployment.address, controllerDeployment.abi, multicall);
                    Safe = (0, utils_1.getGnosisSafeContract)(address, multicall);
                    return [2 /*return*/, {
                            podId: parseInt(podId, 10),
                            Controller: Controller,
                            Name: Name,
                            Safe: Safe
                        }];
            }
        });
    });
}
exports.getPodFetchersByAddressOrEns = getPodFetchersByAddressOrEns;
/**
 * Returns Controller, ENS Name and pod ID for a given pod id
 * @param id - pod ID
 */
function getPodFetchersById(id) {
    return __awaiter(this, void 0, void 0, function () {
        var network, multicall, ens, memberTokenDeployment, MemberToken, controllerAddress, controllerDeployment, Controller, safe, name, Name, Safe;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    network = config_1.config.network, multicall = config_1.config.multicall;
                    ens = (0, ens_1["default"])();
                    memberTokenDeployment = (0, contracts_1.getDeployment)('MemberToken', network);
                    MemberToken = new ethers_1.ethers.Contract(memberTokenDeployment.address, memberTokenDeployment.abi, multicall);
                    return [4 /*yield*/, MemberToken.memberController(id)];
                case 1:
                    controllerAddress = _a.sent();
                    if (controllerAddress === ethers_1.ethers.constants.AddressZero) {
                        throw new Error('Pod ID was not registered on Controller');
                    }
                    controllerDeployment = (0, contracts_1.getControllerByAddress)(controllerAddress, network);
                    Controller = new ethers_1.ethers.Contract(controllerDeployment.address, controllerDeployment.abi, multicall);
                    return [4 /*yield*/, Controller.podIdToSafe(id)];
                case 2:
                    safe = _a.sent();
                    return [4 /*yield*/, ens.getName(safe)];
                case 3:
                    name = (_a.sent()).name;
                    if (!name)
                        throw new Error('Address did not have an ENS name');
                    Name = ens.name(name);
                    Safe = (0, utils_1.getGnosisSafeContract)(safe, multicall);
                    return [2 /*return*/, {
                            podId: id,
                            Safe: Safe,
                            Controller: Controller,
                            Name: Name
                        }];
            }
        });
    });
}
exports.getPodFetchersById = getPodFetchersById;
